import axios from "axios"
import Vue from "vue"
import router from '@/router'

// 大于30min没动作就退出系统---若'发送请求的时间'和'token返回过期'的时间间隔小等于30min，就重新获取token
let limitTime = 30;
let base = "";
// 开发
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
    // base = "http://192.168.102.147:80/rest";
     base = "http://192.168.102.146/rest"; //服务器，svn提交时使用这个
    // base = "http://192.168.102.227/quemei3";
    // base = "http://192.168.102.227/dajun";
    // base = "http ://192.168.102.227/pengzai";
    // base = "http://192.168.102.198:80/tuchao";
    // 阿里测试
    // base = "http://118.178.114.134/rest";
    // 正式！
    // base = "http://120.55.149.143/rest";
}
// 阿里测试
if (process.env.NODE_ENV === 'ali') {
    base = "http://118.178.114.134/rest";
}
// 正式！
if (process.env.NODE_ENV === 'production') {
    base = "http://www.hmzan.com/rest";
}
export { base };

export const http = axios.create({
    baseURL: base,
    timeout: 1200000,
    headers: {
        token: "",
        'Cache-Control': 'no-cache',
        'If-modified-since': '0'
    }
});
Vue.prototype.$http = http; // 为vue实例添加`$http`属性, 方便组件内随时调用

let password = "";
let loginTime = 0;
http.interceptors.request.use(function(res) {
    if(res.url.indexOf("dust")!=undefined && res.url.indexOf("dust")>=0){
        res.headers.token = localStorage.getItem("atmosToken");
    }else{
        res.headers.token = localStorage.getItem("token");
    }
    res.headers.nowTime = Date.now()
    if (res.data == null && res.urlParams == null)
        return res;
    console.log("request参数：", res)
    if (res.method == "get" || res.method == "delete") {
        res.headers.token = localStorage.getItem("token");
        res.urlParams["nowTime"] = Date.now();
        if (!res.isLogin) {
            let userinfo = JSON.parse(localStorage.userinfo);
            res.urlParams["userId"] = userinfo.userId;
            res.urlParams["role"] = userinfo.roleId;
            res.urlParams["unitId"] = userinfo.unitId;
        } else {
            loginTime = new Date().getTime();
            password = res.urlParams.password;
        }
        res.url += "/" + parseUrl(res.urlParams);
        console.log("get参数：", res)
            // console.log("get参数：" + JSON.stringify(res.urlParams), res)
    } else {
        if (!res.data.isLogin) {
            let userinfo = JSON.parse(localStorage.userinfo);
            res.data["userId"] = userinfo.userId;
            res.data["role"] = userinfo.roleId;
            res.data["unitId"] = userinfo.unitId;
        } else {
            loginTime = new Date().getTime();
        }
        console.log("post参数：", res)
            // console.log("post参数：" + JSON.stringify(res.data), res)
    }
    return res;
})

http.interceptors.response.use(function(res) {
        // {"code":"TOKEN_VALIDATE_FAIL","success":false,"message":"token验证失败"}
        let resUrl = res.config.url;
        if (res.data.code && res.data.code != null && res.data.code == "TOKEN_VALIDATE_FAIL") {
            localStorage.clear();
            localStorage.setItem('token', "init");
            router.replace("/login");
        } else if ((Math.abs((new Date().getTime() - loginTime)) / (1000 * 60) >= limitTime)) {
            let userinfo = JSON.parse(localStorage.userinfo);
            http.get("/user/getToken/", { urlParams: { userId: userinfo.userId }, isLogin: true }).then(loginInfo => {
                localStorage.token = loginInfo.data;
                return res;
            })
        } else {
            return res;
        }
        return res;
    },
    function(error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

function getToken() {
    let userinfo = JSON.parse(localStorage.userinfo);
    // console.log(password, userinfo)
    return http.get('/user/login', { urlParams: { userId: userinfo.userId, password: password }, isLogin: true }).then(res => {})
}

function parseUrl(url) {
    let str = JSON.stringify(url);
    if(str.indexOf("limit")>= 0 && str.indexOf("%") >= 0){
        alert('该搜索中含有%，无法搜索！');
        str = str.replace(/%/g,"");
    }
    if(str.indexOf("limit")>= 0 && str.indexOf("/") >= 0){
        alert('该搜索中含有/，无法搜索！');
        str = str.replace(/\//g,"");
    }
    return encodeURIComponent(encodeURIComponent(str));
}



// WEBPACK FOOTER //
// ./src/api/config.api.js